import { tss } from 'tss-react/mui';

const useStyles = tss.create(({ theme }) => ({
  blurBackground: {
    filter: 'blur(5px)'
  },
  card: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%'
  },
  cardContent: {
    height: '100%',
    paddingBottom: '0.5rem !important',
    paddingTop: '0.5rem !important'
  },
  cardHeader: {
    borderBottom: `1px solid ${theme.vars.palette.divider}`,
    fontWeight: 600,
    padding: '0rem 1rem',
    minHeight: '3rem'
  },
  cardInformationText: {
    fontSize: '0.70rem',
    '@media (max-width: 1700px)': {
      fontSize: '0.45rem'
    },
    '@media (max-width: 1500px)': {
      fontSize: '0.7rem'
    }
  },
  dashboardPage: {
    display: 'grid',
    gridTemplateColumns: 'repeat(6, minmax(0, 1fr))',
    gridTemplateRows: 'repeat(5, minmax(5rem, 1fr))',
    gap: '1.5rem',
    height: '100%',
    [theme.breakpoints.down('xl')]: {
      gridTemplateColumns: 'repeat(3, minmax(0, 1fr))',
      gridTemplateRows: 'repeat(12, minmax(200px, 1fr))'
    },
    [theme.breakpoints.down('md')]: {
      gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
      gridTemplateRows: 'repeat(11, minmax(auto, 300px))'
    }
  },
  dashboardMediumItem: {
    height: '100%',
    width: '100%',
    gridRow: 'span 2',
    gridColumn: 'span 2',
    [theme.breakpoints.down('xl')]: {
      gridColumn: 'span 3'
    },
    [theme.breakpoints.down('md')]: {
      gridColumn: 'span 2',
      gridRow: 'span 1',
      minHeight: '18rem'
    }
  },
  dashboardLargeItem: {
    height: '100%',
    width: '100%',
    gridRow: 'span 2',
    gridColumn: 'span 3',
    [theme.breakpoints.down('xl')]: {
      gridColumn: 'span 3'
    },
    [theme.breakpoints.down('md')]: {
      gridColumn: 'span 2',
      gridRow: 'span 1',
      minHeight: '18rem'
    }
  },
  dashboardSmallItem: {
    height: '100%',
    width: '100%',
    gridRow: 'span 1',
    gridColumn: 'span 1'
  },
  dashboardStackedItem: {
    display: 'grid',
    gap: '1.5rem',
    height: '100%',
    width: '100%',
    gridRow: 'span 2',
    gridColumn: 'span 2',
    [theme.breakpoints.down('xl')]: {
      gridColumn: 'span 3'
    },
    [theme.breakpoints.down('md')]: {
      gridColumn: 'span 2',
      gridRow: 'span 1',
      minHeight: '22rem'
    }
  },
  errorChip: {
    backgroundColor: '#FECDD2',
    borderRadius: 6,
    color: '#8C0000'
  },
  select: {
    height: 40
  },
  widgetLoading: {
    display: 'block',
    height: '100%',
    paddingBottom: '0 !important',
    paddingLeft: '0 !important',
    paddingRight: '1rem',
    paddingTop: '0 !important',
    position: 'relative',
    gridTemplateColumns: '40% 60%',
    alignItems: 'center'
  }
}));

export default useStyles;
